import { NgModule } from '@angular/core';
import { FistNameFormatPipe } from './fist-name-format/fist-name-format';
import { LastNameFormatPipe } from './last-name-format/last-name-format';
import { CamelizePipe } from './camelize/camelize';
@NgModule({
	declarations: [FistNameFormatPipe,
    LastNameFormatPipe,
    CamelizePipe],
	imports: [],
	exports: [FistNameFormatPipe,
    LastNameFormatPipe,
    CamelizePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts